import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SolicitudCredito } from 'src/app/models/solicitud-credito.model';

@Component({
  selector: 'app-solicitud-detalle',
  templateUrl: './solicitud-detalle.component.html',
  styleUrls: ['./solicitud-detalle.component.css']
})
export class SolicitudDetalleComponent {
  constructor(
    public dialogRef: MatDialogRef<SolicitudDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SolicitudCredito
  ) {}

  cerrar(): void {
    this.dialogRef.close();
  }
}